@for (s of sizes; track s.id) {
    <div class="{{ s.css + ' ' + (prefix + s.id) }}"></div>
}
